// extracted by mini-css-extract-plugin
export default {"createPollActions":"ButtonsCreatePoll_createPollActions__rYe8K","savePoll":"ButtonsCreatePoll_savePoll__oRq51"};